/* eslint-disable import/no-anonymous-default-export */
import qs from 'querystring';
import getAccessToken from '../utils/helpers/get-access-token';

export default (api) => {

    const enlistDealer = (payload) => {
        return api.post('v1/dealers/enlist', payload, {
            headers: { Authorization: `Bearer ${getAccessToken()}` }
        });
    };

    const fetchWonDeals = (payload) => {
        return api.get(`v1/dealers/won-deals?${qs.stringify(payload)}`);
    };

    const fetchDealerByCode = (dealerCode) => api.get(`/v1/dealers/dealer/${dealerCode}`);

    const requestCallback = (dealerId) => api.post(`/v1/dealers/callback/${dealerId}`);
    return {
        enlistDealer,
        fetchWonDeals,
        fetchDealerByCode,
        requestCallback
    };
};
